
import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../../api.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-create-designation',
  templateUrl: './create-designation.component.html',
  styleUrls: ['./create-designation.component.css']
})
export class CreateDesignationComponent implements OnInit {
  type: any;
  rows: any;
  searchQR: any;
  id: any;
  edit_f:boolean = false;
  constructor(
    private router: Router,
    private _api: ApiService,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this._api.designation_type_list().subscribe(
      (response: any) => {
        console.log(response);
        this.rows = response.Data.reverse();
        console.log(this.rows);
      }
    );
  }
  add() {
    if (this.type == undefined || this.type == '') {
      Swal.fire({
        title: 'Invalid Form',
        text: 'Please Fill all details',
        icon: 'warning',
        showCancelButton: false,
        timer: 1800
      }).then(()=>{
      });
    } else {
      let a = {
        "designation_type": this.type,
        "addedby": "Admin"
      };
      console.log(a);
      this._api.designation_type_add(a).subscribe(
        (response: any) => {
          console.log(response);
          if (response.Code === 200) {
            Swal.fire({
              title: 'Success',
              text: response.Message,
              icon: 'success',
              showCancelButton: false,
              timer: 1800
            }).then(()=>{
            });
            this.type = undefined;
            this.ngOnInit();
          } else {
            Swal.fire({
              title: 'Failed',
              text: response.Message,
              icon: 'warning',
              showCancelButton: false,
              timer: 1800
            }).then(()=>{
            });
          }
        }
      );
    }
  }
  show_edit(item) {
    this.id = item._id;
    this.edit_f = true;
    this.type = item.designation_type
  }
  edit() {
    if (this.type == undefined || this.type == '') {
      Swal.fire({
        title: 'Invalid Form',
        text: 'Please Fill all details',
        icon: 'warning',
        showCancelButton: false,
        timer: 1800
      }).then(()=>{
      });
    } else {
      let a = {
        "_id": this.id,
        "designation_type": this.type,
        "addedby": "Admin"
      };
      console.log(a);
      this._api.designation_type_edit(a).subscribe(
        (response: any) => {
          console.log(response);
          if (response.Code === 200) {
            Swal.fire({
              title: 'Success',
              text: response.Message,
              icon: 'success',
              showCancelButton: false,
              timer: 1800
            }).then(()=>{
            });
            this.edit_f = false;
            this.type = undefined;
            this.ngOnInit();
          } else {
            Swal.fire({
              title: 'Failed',
              text: response.Message,
              icon: 'warning',
              showCancelButton: false,
              timer: 1800
            }).then(()=>{
            });
          }
        }
      );
    }
  }
  delete(id) {
    let a = {
      "_id": id
    }
    this._api.designation_type_delete(a).subscribe(
      (response: any) => {
        console.log(response);
        if (response.Code === 200) {
          Swal.fire({
            title: 'Success',
            text: response.Message,
            icon: 'success',
            showCancelButton: false,
            timer: 1800
          }).then(()=>{
          });
          this.ngOnInit();
        } else {
          Swal.fire({
            title: 'Failed',
            text: response.Message,
            icon: 'warning',
            showCancelButton: false,
            timer: 1800
          }).then(()=>{
          });
        }
      }
    );
  }
  cancel(){
    this.type = undefined;
    this.edit_f = false;
  }
}

